import React, { Component } from "react";
import Chart from "react-apexcharts";
import urls from '../../custom_libraries/urls';
import globalVariables from "../../custom_libraries/globalVariables";
import { post, get, getFreshToken } from '../../custom_libraries/serverRequests';
import ReportDownloadIcon from "../../assets/icons8-download-report-48.png"
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Navigationbar from '../Navigationbar';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import withNavigate from "../../Global_files/WithNavigate";
import LinearProgress from '@mui/material/LinearProgress';
import {Box, Select, MenuItem, Typography, Button, TextField} from '@mui/material';
import InternetConnectionDetector from "../../Global_files/InternetConnectionDetector";
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import NotificationsIcon from '@mui/icons-material/Notifications';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TooltipMUI from '@mui/material/Tooltip';
import './BySites.css';
//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";
import zIndex from "@mui/material/styles/zIndex";
const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#191e29",
      // paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#fafafa",
    },
  },
});

//------------------------------past reports' table styles --------------------------------
const tdStyleLabel = {
  padding: '10px',
  borderBottom: '1px solid #3b475c',
  color: '#a0aec0',
  fontWeight: '600',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  position: 'sticky',
  zIndex: 1
};

const tdStyleValue = {
  padding: '10px',
  borderBottom: '1px solid #3b475c',
  color: '#ffffff',
  textAlign: 'center'
};

//recharts custom styles for offline graph
// Helper to turn raw seconds back into hh:mm:ss strings
const formatSecondsToHMS = (totalSeconds) => {
  if (totalSeconds == null) return "0:00:00";
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

// Custom dark theme tooltip mimicking your exact design
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div style={{
        backgroundColor: '#1e2a3a',
        padding: '10px',
        border: '1px solid #333',
        borderRadius: '4px',
        fontSize: '12px',
      }}>
        <div style={{ marginBottom: '4px' }}><b style={{ color: '#fff' }}>{data.displayDate}</b></div>
        <div style={{ color: '#ffb347' }}>
          ● Offline Duration: {formatSecondsToHMS(data.durationSeconds)}
        </div>
        <div style={{ color: '#5d97d9' }}>
          ● Offline Occurrences: {data.occurrenceCount}
        </div>
      </div>
    );
  }
  return null;
};
//------------------------------------------

class BySites extends Component {
  constructor(props) {
    super(props);
    const todaysDate = new Date().toISOString().split("T")[0];
    this.state = {
      site_list:[],
      devices:[],
      cameras:[],
      sitename:'',
      devicename:'',
      pdf_path :'',
      siteId: null,
      deviceId: null,
      cameraId: null,
      setPdf : null,
      warning : false ,
      warning1: false,
      error : false,
      open_progress_bar: false,
      groups_list: [],
      groupname:'',
      groupId:null,
      responseTaskId:null,
      // taskStatus:'',
      open_progress_bar1:false,
      showModal: false,
      taskStatus1 : "PENDING",
      storedLogo: localStorage.getItem("USER_LOGO") || null,
      taskStatus : '', 
      taskId : null,
      reportStatusMessage: '',
      devices_count:null,
      durationFilter: "24_hours", // New state for duration filter
      todayDate: new Date().toISOString().split("T")[0], // Today's date in YYYY-MM-DD format
      startDate: todaysDate,  // from date
      endDate: todaysDate,    // to date
      warning_alert_report_data: false, // New state for warning alert when no device is selected  for filters in Alert count report generation
      warning_alert_report_data_24h: false,

      // ---- Past Reports Workflow States ----
      showPastReportsCard: false,
      selectedMonthIndex: new Date().getMonth(), // Defaults to current month index (0-11)
      selectedYear: new Date().getFullYear(),
      selectedDateStr: "", // Formatted date string for label e.g., "May 1, 2026"
      pastReportData: [],
      responseMessage: '',
      pageNo: 1, // For pagination of past reports
      totalCount: 0,
      nextPage: null,
      previousPage: null,
      offlineChartData: [], // State to hold offline analysis data for the recharts graph
      totalAlerts: null, // State to hold total alerts count for the alert report
      specify_past_report_type: '', // 
      summaryData: null,  //for past report cards

      options: {
        chart: {
          id: "Camera-matrix",
          stacked: true, //  This is the key
          type: "bar",
          // background: "transparent",
          background: "#1e222d",
        },
        title: {
          text: "Performance and Health of Camera Systems", // Add your label here
          align: "center", // Align the title (options: 'left', 'center', 'right')
          style: {
            fontSize: "14px", // Adjust font size
            fontWeight: "bold", // Adjust font weight
            color: "#c1c1c1", // Adjust title color
          },
        },
        xaxis: {
          categories: ["Total\nCameras", "Cameras\nOnline", "Cameras\nRecording", "Camera\nRetention", "Hard\nDrives ok", "Clock\ncorrect"],
          labels: {
            style: {
              colors: "#e4e4e4da", // lighter gray for dark background
            },
          },
        },
        plotOptions: {
          bar: {
            // horizontal: true,
            // distributed: false, // This makes each bar have its own color
            horizontal: false,
            columnWidth: '50%',
          }
        },
        colors: ["#54a47f", "#ff5959"], // Green for Good, Red for Issues
        theme: {
          mode: "dark", 
        },
      },
      theme: {
        mode: "dark"   
      },
      
      series: [
        { name: "Healthy", data: [0, 0, 0, 0, 0, 0] },
        { name: "Issues", data: [0, 0, 0, 0, 0, 0] }
      ],

      options1: {
        chart: {
          id: "Image-quality-assessment",
          // background: "transparent",
          background: "#1e222d",
        },
        title: {
          text: "Image Quality Assessment with counts", // Add your label here
          align: "center", // Align the title (options: 'left', 'center', 'right')
          style: {
            fontSize: "14px", // Adjust font size
            fontWeight: "bold", // Adjust font weight
            color: "#c1c1c1", // Adjust title color
          },
        },
        xaxis: {
          categories: ["Healthy", "Not Yet Rated By Operator", "Blocked", "Blurred", "Low Light", "Tilted / FOV"],
          labels: {
            style: {
              colors: "#c4c4c4da", // lighter gray for dark background
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true, // This makes each bar have its own color
          }
        },
        colors: [ "#5eab87", "#5d97d9", "#ffab37", "#febb5d", "#febb5d", "#febb5d" ], // Colors for each category
        theme: {
          mode: "dark",
        },
      },
      series1: [
        {
          name: "Count",
          data: [0, 0, 0, 0, 0, 0]
        }
      ],
      //------------Alert report states----------------
      alertSeries: [],
      alertOptions: {
        chart: {
          type: "bar",
          stacked: true,
          background: "#1e222d",
        },
        title: {
          text: "Alert Count by Camera",
          align: "center",
          style: {
            color: "#ededed",
            fontSize: "14px",
            fontWeight: "bold",
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: "#c4c4c4da",
            },
             trim: true,
          },
        },
        legend: {
          position: "bottom",
          labels: {
            colors: "#E0E0E0",
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 6,
            columnWidth: '20%',
          },
        },
        theme: {
          mode: "dark",
        },

        colors: ["#4FC3F7", "#6df7ab", "#BA68C8"],

        fill: {
          opacity: 1,
        },
      },

    };
    this.downloadRequested = false; //flag to store the boolean value based on whether the user clicks on download report button or not to call the function on SUCCESS status from websocket

  }

 async componentDidMount(){
    setTimeout(() => {
      this.validateSignedIn();
    }, 0);
    // this.connectWebSocket();
    this.connect();
    this.getReportData();  
    this.getSitesList();
    // this.getGroupsList();
    
  }

  componentWillUnmount() {
    this.cleanup(); // Clean up resources from websocket and polling
  }


  validateSignedIn = async () => {
    try {
      let is_fresh_token = await getFreshToken();
      console.log("Fresh Token:", is_fresh_token);
  
      if (!is_fresh_token) {
        console.log("Navigating to login...");
        this.props.navigate("/");
        return;
      }
    } catch (error) {
      console.error("Error in validateSignedIn:", error);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
        // this.state.warning !== prevState.warning ||
        this.state.error !== prevState.error ||
        this.state.warning_alert_report_data !== prevState.warning_alert_report_data
    ) {
        if (
            // this.state.warning ||
            this.state.error ||
            this.state.warning_alert_report_data
        ) {
            setTimeout(() => {
                this.setState({
                  // warning : false ,
                  error : false,
                  warning_alert_report_data: false,
                });
            }, 3000); // 3 second
        }
    }
    
  // clean up report socket connection if siteId/deviceId/cameraId/status changes
    // if (
    // prevState.taskStatus !== "SUCCESS" &&
    // this.state.taskStatus === "SUCCESS"
    // ) {
    //   this.DownloadReport();
    // }

    // const { siteId, deviceId, cameraId } = this.props;
    // if (
    //   prevProps.siteId !== siteId ||
    //   prevProps.deviceId !== deviceId ||
    //   prevProps.cameraId !== cameraId
    // ) {
    //   this.cleanup();
    // }
  }

      getGroupsList = async () => {
        try {
          this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken getGroupsList---------", access_tocken);
          let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
          }

          console.log("Fetching data from:", urls.GET_ALL_GROUPS_INCLUDING_SUBGROUPS); // Update URL for fetching sites
          const response = await get(urls.GET_ALL_GROUPS_INCLUDING_SUBGROUPS, headers);
          console.log("response getGroupsList ===> ", response);
          this.stopLoading();
          if (!response) {
            console.error("Failed to fetch getGroupsList.");
            this.setState({ groups_list: [] });
            return;
          }

          this.setState({ groups_list: response.data});
        } catch (error) {
          console.error("Error in getGroupsList:", error);
          this.setState({ groups_list: [] });
        }
      };
      // uncommet for grouping feature ----------
      // getSitesList = async (groupId) => {
      //     try {
      //         let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      //         console.log("--------auth tocken---------", access_tocken);
      //         let headers = {
      //             'content-type': 'application/json',
      //             'Authorization': `Bearer ${access_tocken}`
      //         }
  
      //         console.log("Fetching data from:", urls.GET_SITES_BY_GROUP_ID(groupId)); // Update URL for fetching sites
      //         const response = await get(urls.GET_SITES_BY_GROUP_ID(groupId), headers);
      //         console.log("response===> ", response);
  
      //         if (!response.data) {
      //             console.error("Failed to fetch site list.");
      //             this.setState({ site_list: [] });
      //             return;
      //         }
  
      //         this.setState({ site_list: response.data });
      //     } catch (error) {
      //         console.error("Error in getSitesList:", error);
      //         this.setState({ site_list: [] });
      //     }
      // };
      //-------------------------------------------

      getSitesList = async () => {
          try {
              let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
              console.log("--------auth tocken---------", access_tocken);
              let headers = {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${access_tocken}`
              }
  
              console.log("Fetching data from:", urls.GET_SITES_BY_USER); // Update URL for fetching sites
              const response = await get(urls.GET_SITES_BY_USER, headers);
              console.log("response===> ", response);
  
              if (!response) {
                  console.error("Failed to fetch site list.");
                  this.setState({ site_list: [] });
                  return;
              }
  
              this.setState({ site_list: response.data[0] });
          } catch (error) {
              console.error("Error in getSitesList:", error);
              this.setState({ site_list: [] });
          }
      };

      getDevicesListById = async (site_id) => {
          // let site_id = localStorage.getItem(globalVariables.SITE_ID);
          // this.setState({ site_id: site_id });
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
          let allDevices = [];
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'content-type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`
          }
          console.log("---------globalVariables site_id--------", site_id);
          try {
            const url = urls.GET_DEVICES_BY_SITE_FOR_ANALYTICS(site_id);
            const response = await get(url, headers); // Replace with your actual API call
            // const rtspSiteDevices = await this.getRtspCamerasDevicesListBySiteId(site_id);
            allDevices = [...allDevices, ...response.data.devices];
            // console.log("url----------->", url);
            console.log("API Response:----------getDevicesListById site_id--------------------------------->>>", response)
      
            if (allDevices.length > 0) {
              console.log("res",allDevices);
              this.setState({ devices: allDevices });
              this.setState({ devices_count:response.data.summary });
              // this.setState({ deviceId:deviceData.id });
            }
            else {
              console.error("No data returned from the API");
              this.setState({ devices: [] });
            }
          } catch (error) {
            console.error("Error fetching devices from API:", error);
          }
        };

      getRtspCamerasDevicesListBySiteId = async (siteId) => {
        try {
          // this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
          }
          const response = await get(urls.GET_DEVICES_OF_SEPARATE_RTSP_CAMERAS(siteId), headers); //  API call to get the rtsp camera's sites(devices) list w.r.t selected group
          // this.stopLoading();
          console.log("API Response:---getRtspCamerasDevicesListBySiteId---------------------------------------->>>", response.data)
    
          if (response.data) {
            // const rtsp_cameras_device_list = response.data;
            // this.setState({ loading: false});
            return response.data;
          }
          else {
                console.error("No data returned from the API");
                return [];
            }
        } catch (error) {
          console.error("Error fetching devices from API:", error);
        }
      };

      // getCamerasListByDeviceId = async (deviceId) => {
      //   try {
      //     let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      //     console.log("--------auth tocken---------", access_tocken);
      //     let headers = {
      //         'content-type': 'application/json',
      //         'Authorization': `Bearer ${access_tocken}`
      //     }
          
      //     console.log("deviceId -------------->:", deviceId);
      //     //this.setState({ : [] }); 
          
      //     const url = urls.CAMERAS_BY_DEVICE(deviceId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      //     const response = await get(url, headers); // Perform the API call using the constructed URL
      //     console.log(`API Response for device ${deviceId}:`, response);
      //     if (Array.isArray(response.data)) {
      //       console.log(`API Response for device ${deviceId}:`, response);
      //       this.setState({ cameras: response.data });
    
      //     } else {
      //       console.error("No valid data returned from the get-camera API");
      //       this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
      //     }
      //   } catch (error) {
      //     console.error("Error fetching cameras from API:", error);
      //     this.setState({ cameras: [] }); // Clear the cameras list in case of error
      //   }
      // };

      //comment this for grouping feature-------
      // handleInputChange = async (e) => {
      //   const { name, value } = e.target;
      //   this.setState({ [name]: value });
      //   if (name === "groupname") {
      //     // When a site is selected, fetch the devices for that site
      //     this.setState({
      //       groupId: value,
      //       sitename:"",
      //       devicename: "", // Clear selected device
      //       deviceId: "",   // Reset device ID
      //       // cameraName: "", // Clear selected camera
      //       cameraId: "",   // Reset camera ID
      //     })
      //     // await this.getSiteListByGroupId(value);
      //     await this.getSitesList(value);
      //   }

      //   if (name === "sitename") {
      //     // When a site is selected, fetch the devices for that site
      //     this.setState({
      //       siteId: value,
      //       devicename: "", // Clear selected device
      //       deviceId: "",   // Reset device ID
      //       // cameraName: "", // Clear selected camera
      //       cameraId: "",   // Reset camera ID
      //     })
      //     await this.getDevicesListById(value);
      //   }
      //   if (name === "devicename") {
          
      //     // When a site is selected, fetch the devices for that site
      //     await this.getCamerasListByDeviceId(value);
      //     this.setState({deviceId: value})
      //   }
      //   if (name === "cameraName") {
      //     // When a site is selected, fetch the devices for that site
      //     this.setState({cameraId: value})
      //   }
      // };
      //-----------------------------------------

      handleInputChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "sitename") {
          // When a site is selected, fetch the devices for that site
          this.setState({
            siteId: value,
            devicename: "", // Clear selected device
            deviceId: "",   // Reset device ID
            devices:[],
            totalAlerts: null,
            // cameraName: "", // Clear selected camera
            // cameraId: "",   // Reset camera ID
          })
          await this.getDevicesListById(value);
        }
        if (name === "devicename") {
          
          // When a site is selected, fetch the devices for that site
          
          this.setState({totalAlerts: null, deviceId: value});
          // await this.getCamerasListByDeviceId(value);
        }
        if (name === "cameraName") {
          // When a site is selected, fetch the devices for that site
          this.setState({totalAlerts: null, cameraId: value})
        }
      };

    getReportData = async() => {
      console.log("------inside getReportData----");
      const {siteId, deviceId, devices, showPastReportsCard} = this.state;
      console.log("-----showPastReportsCard------", showPastReportsCard);
      if (showPastReportsCard === true) {
        this.setState({ showPastReportsCard: false, pastReportData: [], summaryData: null }); // Reset showPastReportsCard state on new report generation attempt
      } 
      // ✅ Early return if no cameras for selected device
      if (siteId && (!Array.isArray(devices) || devices.length === 0)) {
      this.setState({
        warning: true,
        series: [{ name: "Camera-matrix", data: [0, 0, 0, 0, 0, 0] }],
        series1: [{ name: "series-2", data: [0, 0, 0, 0, 0, 0] }]
      });
      return; // ⛔ Prevent API call
    }
 
        let data = { }
        if (siteId) {
          // Add cameraId only if selected
          data.sitedb = siteId;
        }
        
      //  if (cameraId) {
      //   data.cameras = [cameraId];
      //    } 

        if (deviceId) {
          // Add cameraId only if selected
          data.device = deviceId;
        }
        data = JSON.stringify(data);
        console.log("----post data in fetch report----", data);

        try {
          this.startLoading();
          //-- to reset the task id and status when new filter is applied.
          this.downloadRequested = false;

      this.setState({
            responseTaskId: null,
            taskStatus: null,
          });
          //------------------------------

          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'Content-Type': 'application/json', // Expecting a JSON response',
              'Authorization': `Bearer ${access_tocken}`
          }
          const response = await post(urls.GENERATE_REPORT, data, headers); // Replace with your actual API call
          console.log("API Response getReportData:", response);
          console.log("API Response.report_file:", response.data.report_file);
          console.log("API Response.data.task_id:", response.data.task_id);
          this.stopLoading();
          await this.getAlertReportData();
          
          if (response.data && response.data.matrix_data) {

            this.setState({ pdf_path: response.data.report_file, responseTaskId: response.data.task_id });
           // Extract camera_view_results from matrix_data
          //  if (response.data.task_id){
          //  this.setState({taskStatus1: "PENDING"});
          //  }

          // / ── Sync path (≤32 cameras): backend already finished ──
            if (response.data.status === "SUCCESS" && response.data.download_url) {
              this.setState({
                taskStatus: "SUCCESS",
                directDownloadUrl: response.data.download_url,
              });
              console.log("⚡ Sync report ready — no polling needed");
            }
            // ── Async path (>32 cameras): WebSocket will deliver status ──
            else {
              this.setState({
                taskStatus: "PROCESSING",
                directDownloadUrl: null,
              });
            }
            const { camera_matrix_results } = response.data.matrix_data;
            console.log("--------camera_matrix_results-----------:", camera_matrix_results);
            console.log("--------response.matrix_data.live_cameras_count-----------:", response.data.matrix_data.live_cameras_count);
            // Map the data for the chart
            const mData = response.data.matrix_data;
            const hddParts = mData.hdd_status.split('/');
            const hddHealthy = parseInt(hddParts[0], 10) || 0; // 73
            const hddTotal = parseInt(hddParts[1], 10) || 0;   // 111
            const hddIssues = hddTotal - hddHealthy;           // 38

            const positiveData = [
              mData?.total_cameras || 0,
              mData?.live_cameras_count || 0,       // Cameras Online
              mData?.cameras_with_last24h_recording || 0,  // Cameras Recording
              (mData?.total_cameras - mData.cameras_meeting_policy) || 0,           // Camera Retention
              // mData.hdd_status === "ok" ? 1 : 0, // Hard Drives ok (1 for "ok", 0 for not)
              // parseInt(mData.hdd_status.split('/')[0], 10),
              hddHealthy,
              mData?.timezone_match || 0    // Clock correct (1 for true, 0 for false)
            ];
            // 2. "Negative" Data (The missing/error counts)
            // Total Cameras usually doesn't have a 'negative' pair, so we use 0
            
            const negativeData = [
              0, 
              (mData.total_cameras - mData.live_cameras_count) || 0,
              (mData.total_cameras - mData.cameras_with_last24h_recording) || 0,
              (mData.cameras_meeting_policy) || 0,
              // (parseInt(mData.hdd_status.split('/')[1], 10) - parseInt(mData.hdd_status.split('/')[0], 10)) || 0,
              hddIssues,
              (mData.total_devices - mData.timezone_match) || 0    // Clock correct (1 for true, 0 for false)
            ];
            
            const cameraRatingChart = [
              // response.matrix_data.camera_view_results.ai_rating.block,       // AI rating Cameras Block
              // response.matrix_data.camera_view_results.ai_rating.healthy,       // Cameras Healthy
              response.data?.matrix_data?.camera_view_results?.ai_rating.healthy || 0,
              response.data?.matrix_data?.camera_view_results?.operator_rating["not yet rated"] || 0,
              response.data?.matrix_data?.camera_view_results?.ai_rating.block || 0,
              response.data?.matrix_data?.camera_view_results?.ai_rating.blur || 0,
              response.data?.matrix_data?.camera_view_results?.ai_rating["low light"] || 0,
              response.data?.matrix_data?.camera_view_results?.ai_rating.tilt || 0,
              // response.data.matrix_data.camera_view_results.ai_rating.mute || 0,
            ]
            // console.log("hello", response.matrix_data.camera_view_results.ai_rating.healthy);
            // Update the chart's series with the fetched data
            this.setState({
                // series: [
                //     {
                //         name: "Count",
                //         data: chartData
                //     }
                // ],
                series: [
                  {
                    name: "Healthy",
                    data: positiveData
                  },
                  {
                    name: "Issues",
                    data: negativeData
                  }
                ],
                series1: [
                  {
                      name: "Count",
                      data: cameraRatingChart
                  }
              ]
            });
          }
          else if (response.error === 'No devices found for the provided criteria'){
            this.setState({warning:true})
            const chartData = [0, 0, 0, 0, 0];
            const cameraRatingChart = [0, 0, 0, 0, 0, 0];
            // Update the chart's series with the fetched data
            this.setState({
              series: [
                  {
                      name: "Count",
                      data: chartData
                  }
              ],
              series1: [
                {
                    name: "Count",
                    data: cameraRatingChart
                }
            ],
          });
          }
          else if (response.error === "No devices found for the user's sites"){
            this.setState({warning:true})
            const chartData = [0, 0, 0, 0, 0];
            const cameraRatingChart = [0, 0, 0, 0, 0, 0];
            // Update the chart's series with the fetched data
            this.setState({
              series: [
                  {
                      name: "Count",
                      data: chartData
                  }
              ],
              series1: [
                {
                    name: "Count",
                    data: cameraRatingChart
                }
            ],
          });
          }
          else if (response.error === 'No sites found for the user'){
            this.setState({warning1:true})
            const chartData = [0, 0, 0, 0, 0];
            const cameraRatingChart = [0, 0, 0, 0, 0, 0];
            // Update the chart's series with the fetched data
            this.setState({
              series: [
                  {
                      name: "Count",
                      data: chartData
                  }
              ],
              series1: [
                {
                    name: "Count",
                    data: cameraRatingChart
                }
            ],
          });
          }
          else if (response === false ){
            this.stopLoading();
            alert("Either Device is unreachable or server error");
          }
          else {
            this.stopLoading();
            console.error("No data returned from the API");
            this.setState({warning: true,
              series: [{ name: "Camera-matrix", data: [0, 0, 0, 0, 0, 0] }],
              series1: [{ name: "series-2", data: [0, 0, 0, 0, 0, 0] }]
            })
          }
        } catch (error) {
          this.stopLoading();
          console.error("Error fetching devices from API:", error);
          alert("Device is unreachable or server error");
        } finally {
          // this.connect();
        }
      }

      // DownloadReport = async () => {
      //   // this.connect();
      //   const { pdf_path, responseTaskId, taskStatus, taskId } = this.state;
      //   console.log("----pdf-path-------", pdf_path);
      //   // this.setState({ showModal: false });
      //   this.startLoading();
      //   console.log("---DownloadReport---taskStatus, taskId, responseTaskId-------",taskStatus, taskId, responseTaskId);
      //   this.downloadRequested = true;

      //   if (!taskStatus) {
      //     this.setState({
      //       showModal: true,
      //       reportStatusMessage: "Fetching report. Please wait..."
      //     });
      //     return;
      //   }

      //   if (taskStatus === "SUCCESS") {
      //         this.setState({ showModal: false });
      //         this.stopLoading();
      //         this.openReport(responseTaskId); //new function handler for download report, bz when status changes to 'SUCCESS', the modal closes but the report was not shown in new tab, when user reclicks on download button again, then the report was getting opened
      //   }else if (taskStatus === "PROCESSING") {
      //         this.stopLoading();
      //         this.setState({ showModal: true, reportStatusMessage: "Report is being generated. Please wait..." });
      //         // return;
      //   }
      //   else {
      //     this.stopLoading();
      //     this.setState({ showModal: true, reportStatusMessage: "Report generation failed. Try again later." });
      //   }
      // };

    getAlertReportData = async () => {
      const { deviceId, startDate, endDate, showPastReportsCard } = this.state;
       this.setState({
        alertSeries: [
          { name: "Car", data: [] },
          { name: "Person", data: [] },
          { name: "Motorbike", data: [] }
        ],
        alertOptions: {
          ...this.state.alertOptions,
          xaxis: { categories: [] }
        },
      });

      if(showPastReportsCard === true) {
        this.setState({ showPastReportsCard: false, pastReportData: [], summaryData: null }); // Reset showPastReportsCard state on new report generation attempt
      }

      try {
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);

        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_tocken}`,
        };
        let result
        if (this.state.durationFilter === "24_hours") {
          if (!deviceId || !startDate || !endDate) {
            this.setState({ warning_alert_report_data_24h: true });
            return;
          }
          this.setState({ warning_alert_report_data_24h: false });
           const response = await get(
          urls.GET_ALERT_PER_CAMERA_REPORT_FOR_24_HOURS(deviceId),
          headers
        );
          result = response;
        }
        else {
          if (!deviceId) {
            this.setState({ warning_alert_report_data: true });
            return;
          }
          const response = await get(
            urls.GET_ALERT_PER_CAMERA_REPORT_FOR_CUSTOM_RANGE(deviceId, startDate, endDate),
            headers
          );
          result = response;
        }
        await this.getofflineReportData();

        console.log("API Response:", result);

        if (result?.cameras?.length) {
          const cameras = result.cameras;

          // ✅ X-axis labels (camera names)
          const categories = cameras.map((cam) => cam.camera_name);

          // ✅ Build stacked series
          const totalAlerts = result.total_alerts
          this.setState({ totalAlerts: totalAlerts });
          const carData = cameras.map((cam) => cam.car || 0);
          const personData = cameras.map((cam) => cam.person || 0);
          const motorbikeData = cameras.map((cam) => cam.motorbike || 0);
          // const nonThreatData = cameras.map((cam) => cam.trueNonThreat || 0);

          const alertSeries = [
            { name: "Car", data: carData },
            { name: "Person", data: personData },
            { name: "Motorbike", data: motorbikeData },
            // { name: "Non-Threat", data: nonThreatData },
          ];

          this.setState((prevState) => ({
            alertSeries,
            alertOptions: {
              ...prevState.alertOptions,
              xaxis: {
                ...prevState.alertOptions.xaxis,
                categories,
              },
            },
          }));
          return;
        }
      } catch (error) {
        console.error("Error fetching alert report:", error);
      }
    };

    getofflineReportData = async() => {
      const { deviceId, startDate, endDate } = this.state;
      // — safe reset
      // this.setState(prevState => ({
      //   offlineOptions: {
      //     ...prevState.offlineOptions,
      //     xaxis: {
      //       type: "category",
      //       labels: {
      //         style: { colors: "#c4c4c4da" },
      //         rotate: -45,
      //       },
      //       tickPlacement: "on",
      //       // ✅ No categories key at all — omitting it is safe, undefined is not
      //     },
      //     annotations: { points: [] },  // ✅ clear previous single-point annotation dot
      //     markers: {
      //       size: [0, 6],
      //       strokeWidth: 2,
      //       offsetX: 0,
      //       offsetY: 0,
      //       hover: { size: 8 },
      //     },
      //   },
      //   offlineSeries: [
      //     { name: "Offline Duration", type: "column", data: [] },
      //     { name: "Offline Occurrence Count", type: "line", data: [] },
      //   ],
      // }));

      // 1. Immediately reset state to show loading/empty chart states cleanly- used recharts library for offline report.
      this.setState({
        offlineChartData: []
      });

      try {
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);

        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_tocken}`,
        };
        let result
        if (this.state.durationFilter === "24_hours") {
          if (!deviceId) {
            this.setState({ warning_alert_report_data_24h: true });
            return;
          }
          this.setState({ warning_alert_report_data_24h: false });
           const response = await get(
          urls.GET_DEVICE_OFFLINE_SUMMARY(deviceId),
          headers
        );
          result = response;
        }
        else if(this.state.durationFilter === "past_reports"){
          this.togglePastReportsWorkflow();
           return;
        }
        else {
          if (!deviceId) {
            this.setState({ warning_alert_report_data: true });
            return;
          }
          const response = await get(
            urls.GET_DEVICE_OFFLINE_SUMMARY_FOR_CUSTOM_RANGE(deviceId, startDate, endDate),
            headers
          );
          result = response;
        }

        console.log("API Response getofflineReportData:", result);
             

        let seriesData = [];
        let countSeriesData = [];

      // 3. Process the result into a standardized shape for Recharts
    let formattedChartData = [];

    if (result?.summary_by_date) {
      // ✅ CASE A: CUSTOM DATE RANGE MULTI-POINT RESPONSE
      const summary = result.summary_by_date;

      const entries = Object.entries(summary).sort(
        (a, b) => new Date(a[0]) - new Date(b[0])
      );

      formattedChartData = entries.map(([date, value]) => ({
        displayDate: new Date(date + "T12:00:00").toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
        }),
        durationSeconds: this.durationToSeconds(value.total_offline_duration || "00:00:00"),
        occurrenceCount: value.offline_count || 0,
      }));

    } else if (result) {
      // ✅ CASE B: 24 HOURS SINGLE POINT RESPONSE (OR SINGLE OBJECT BACK)
      const todayLabel = "Last 24h";

      formattedChartData = [
        {
          displayDate: todayLabel,
          durationSeconds: this.durationToSeconds(result.total_offline_duration || "00:00:00"),
          occurrenceCount: result.offline_count || 0,
        },
      ];
    }

    console.log("Formatted Recharts Data:", formattedChartData);

    // 4. Update state with unified dataset array
    this.setState({
      offlineChartData: formattedChartData,
    });
      } catch (error) {
        console.error("Error fetching alert report:", error);
      }

    }

      DownloadReport = async () => {
        const { responseTaskId, taskStatus, directDownloadUrl } = this.state;
        console.log("---DownloadReport--- taskStatus:", taskStatus, "responseTaskId:", responseTaskId);

        this.downloadRequested = true;

        // ── Sync path: URL already in hand ──
        if (taskStatus === "SUCCESS" && directDownloadUrl) {
          window.open(directDownloadUrl, "_blank", "noopener,noreferrer");
          return;
        }

        // ── Async path: task finished via WebSocket ──
        if (taskStatus === "SUCCESS" && responseTaskId) {
          this.setState({ showModal: false });
          this.openReport(responseTaskId);
          return;
        }

        // ── Still generating ──
        if (taskStatus === "PROCESSING") {
          this.setState({
            showModal: true,
            reportStatusMessage: "Report is being generated. Please wait...",
          });
          return;
        }

        // ── Not yet started (user clicked before getReportData finished) ──
        this.setState({
          showModal: true,
          reportStatusMessage: "Fetching report. Please wait...",
        });
      };

      openReport = async (taskId) => {
        try {
          
          // Preparing the request body--
          const data = JSON.stringify({ task_id: taskId });
          console.log("----task_id in post data in openReport----", data);
          // Retrieve the access token
          const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
      
          // Define headers --
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
          };
      
          // Make the POST request--
          const response = await fetch(urls.DOWNLOAD_REPORTS, {
            method: 'POST',
            headers: headers,
            body: data,
          });
          

          // Parsing the response JSON
        const result = await response.json();

        console.log("Download API result:", result);

        const downloadUrl = result?.data?.download_url;

        if (downloadUrl) {
          // Opening PDF preview in new tab
          window.open(downloadUrl, "_blank", "noopener,noreferrer");
        } else {
          throw new Error("Download URL not found");
        }
            console.log("PDF preview opened successfully");
            this.stopLoading();

          } catch (error) {
            console.error("Error fetching the PDF file:", error);
          }
      }

      clearFilter = async () => {
       let todayDate = new Date().toISOString().split("T")[0]
        this.setState({
          sitename: "",
          devicename: "",
          // cameraName: "",
          siteId: null,
          deviceId: null,
          // cameraId: null,
          pdf_path: null,
          warning: false,
          warning1: false,
          error: false,
          responseTaskId: null,
          taskStatus: null,          // ← add
          directDownloadUrl: null,   // ← add
          devices_count:null,
          devices : [],
          durationFilter: "24_hours", // New state for duration filter
          startDate: todayDate,  // from date
          endDate: todayDate,    // to date
          offlineChartData: [],
          alertSeries: [
            { name: "Car", data: [] },
            { name: "Person", data: [] },
            { name: "Motorbike", data: [] }
          ],
          totalAlerts: null,
          showPastReportsCard: false,
          pastReportData: [],
          summaryData: null,
          specify_past_report_type: '',
          
        });
        setTimeout(() => {
        this.getReportData();
        },500);
      }

      startLoading = () => {
        console.log("startloading");
    
        this.setState({ open_progress_bar: true });
    }
    
    stopLoading = () => {
        this.setState({ open_progress_bar: false });
    }

   // Method to handle modal close
   handleCloseModal = () => {
    // const{selectedSite}= this.state
      this.setState({ showModal: false});
  };

  handleDurationFilterChange = (event) => {
    const value = event.target.value;
    let todayDate = new Date().toISOString().split("T")[0]
    this.setState({ durationFilter: value, sitename: "", devicename: "", siteId: null, deviceId: null, pastReportData:[], summaryData: null, pageNo:1,

          // cameraId: null,
          warning: false,
          warning1: false,
          error: false,
          responseTaskId: null,
          taskStatus: null,          // ← add
          directDownloadUrl: null,   // ← add
          devices_count:null,
          devices : [],
          startDate: todayDate,  // from date
          endDate: todayDate,    // to date
          offlineChartData: [],
          alertSeries: [
            { name: "Car", data: [] },
            { name: "Person", data: [] },
            { name: "Motorbike", data: [] }
          ],
          totalAlerts: null,
          showPastReportsCard: false,
          specify_past_report_type: '',
     });
    
  };

  connect = () => { //funtion to connec the websocket for getting the status of report downloading process.
    const { responseTaskId } = this.state;
    console.log("---Inside Connect to  report websocket ---$$$$$$$");
        let authToken = localStorage.getItem(globalVariables.AUTH_TOKEN);
  
        // this.ws = new WebSocket(
        //   `${process.env.REACT_APP_WS_URL}/ws/nvr/tenant/${tenantId}/device/${deviceName}/`
        // );
        this.ws = new WebSocket(`wss://api.eyeon8i.com/ws/report-status/?token=${authToken}`);  // prod server
        // this.ws = new WebSocket(`wss://devapi.neudeep.com/ws/report-status/?token=${authToken}`); //dev server.
        // this.ws = new WebSocket("ws://localhost:8000/ws/nvr/tenant/tenantA/device/device123/");
        this.ws.onopen = () => {
          console.log("$$$$$$$--- Connected to  report websocket ---$$$$$$$");
        };
  
        this.ws.onmessage = (e) => {
          const msg = JSON.parse(e.data);
          const { responseTaskId } = this.state;
          console.log("websocket message for status of report downloading process", msg);

          // Ignore messages for old tasks
            if (!responseTaskId || msg.task_id !== responseTaskId) {
              console.log("Ignoring stale task update:", msg.task_id);
              return;
            }

            // This message belongs to the latest filter
            // this.setState({
            //   taskStatus: msg.status,
            //   taskId: msg.task_id,
            //   pdf_path: msg.pdf_filename,
            // });
  
          // received status update 
          
          if (msg.status) {
            this.setState({ taskStatus: msg.status, taskId : msg.task_id, pdf_path: msg.pdf_filename });
            console.log("------taskStatus-------",msg.status, msg.task_id);

            if(msg.status === "SUCCESS") {
              this.setState({ showModal: false });
              // AUTO-DOWNLOAD if user already clicked
              if (this.downloadRequested) {
                this.openReport(responseTaskId);
                this.downloadRequested = false; // reset
              }
            }
            
          }
          
        };
  
        this.ws.onclose = () => {
          console.log(" Reconnecting in 3s...");
          this.reconnectTimer = setTimeout(this.connect, 3000);
        };
  
        this.ws.onerror = () => {
          this.ws.close();
        };
      };
    
      cleanup = () => {
        if (this.reconnectTimer) {
          clearTimeout(this.reconnectTimer);
          this.reconnectTimer = null;
        }
  
        if (this.ws) {
          this.ws.close();
          this.ws = null;
        }
      };

    handleDateChange = (event) => { //function to change the selected date from the filter
      const { name, value } = event.target;
      const { startDate, endDate } = this.state;
      console.log("startdate", name, value);

      // If user changes START DATE
      if (name === "startDate" && endDate && value > endDate) {
        alert("Start date cannot be greater than End date");
        return;
      }

      // If user changes END DATE
      if (name === "endDate" && startDate && value < startDate) {
        alert("End date cannot be less than Start date");     
        return;
      }

      // Clear error and update state
      this.setState({
        [name]: value,
        totalAlerts: null, // Clear total alerts when date changes,
        summaryData: null, // Clear summary data when date changes
        pastReportData: [], // Clear past report data when date changes
        pageNo: 1, // Reset pagination to first page on date change
      });
    };

  durationToSeconds = (duration) => {
  if (!duration) return 0;

  const [h, m, s] = duration.split(":").map(Number);
  return h * 3600 + m * 60 + s;
  };

  // ---- Past Reports Dynamic View Helpers ----
  togglePastReportsWorkflow = () => {
    this.setState(prevState => ({
      showPastReportsCard: !prevState.showPastReportsCard,
      // selectedDateStr: "" // Reset when toggled
      // startDate: "", // Clear custom date range
      // endDate: "",
    }));
  }

  // handleMonthSelect = (monthIndex) => {
  //   this.setState({ selectedMonthIndex: monthIndex, selectedDateStr: "" });
  // }

  // handleDaySelect = (dayNumber) => {
  //   const { selectedMonthIndex, selectedYear } = this.state;
  //   // Format label text to match image workflow design (e.g., "May 1, 2026") for user-friendly display on the card
  //   const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  //   const formattedDate = `${monthNames[selectedMonthIndex]} ${dayNumber}, ${selectedYear}`;
  //   this.setState({ selectedDateStr: formattedDate });

  //   // Convert month/day to 2-digit format for API (e.g., "2026-05-01")
  //   const month = String(selectedMonthIndex + 1).padStart(2, '0');
  //   const day = String(dayNumber).padStart(2, '0');

  //   // Final format: YYYY-MM-DD
  //   const formattedDateforAPI = `${selectedYear}-${month}-${day}`;
  //   this.getCamerahealthPastReports(formattedDateforAPI); // Fetch the past report data for the selected date
  // }

  handleShowPastReportPdf = () => {
    alert(`Fetching Past Archived Report for: ${this.state.selectedDateStr}`);
    // Place your production download endpoint logic or API trigger here.
  }

  // renderCalendarGrid = () => {
  //   const { selectedMonthIndex, selectedYear } = this.state;
    
  //   // Day headers
  //   const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    
  //   // Calculate first day and total days in month
  //   const firstDayOfMonth = new Date(selectedYear, selectedMonthIndex, 1).getDay();
  //   const totalDaysInMonth = new Date(selectedYear, selectedMonthIndex + 1, 0).getDate();
    
  //   const gridCells = [];
    
  //   // Add empty ghost cells for offsets
  //   for (let i = 0; i < firstDayOfMonth; i++) {
  //     gridCells.push(<Box key={`empty-${i}`} sx={{ width: '45px', height: '36px', border: '1px solid #2d3748', borderRadius: '6px', backgroundColor: 'transparent' }} />);
  //   }
    
  //   // Build actual calendar block elements
  //   for (let day = 1; day <= totalDaysInMonth; day++) {
  //     gridCells.push(
  //       <Box 
  //         key={`day-${day}`} 
  //         onClick={() => this.handleDaySelect(day)}
  //         sx={{ 
  //           width: '45px', 
  //           height: '36px', 
  //           border: '1px solid #4a5568', 
  //           borderRadius: '6px', 
  //           display: 'flex', 
  //           alignItems: 'center', 
  //           justifyContent: 'center',
  //           fontSize: '13px',
  //           fontWeight: 'bold',
  //           cursor: 'pointer',
  //           backgroundColor: '#1e2533',
  //           '&:hover': {
  //             backgroundColor: '#3182ce',
  //             borderColor: '#63b3ed'
  //           }
  //         }}
  //       >
  //         {day}
  //       </Box>
  //     );
  //   }

  //   return (
  //     <Box sx={{ width: '100%', maxWidth: '360px', mt: 2 }}>
  //       {/* Days Header */}
  //       <Box display="grid" gridTemplateColumns="repeat(7, 1fr)" gap={1} textAlign="center" mb={1}>
  //         {daysOfWeek.map(day => (
  //           <Typography key={day} sx={{ fontSize: '11px', color: '#a0aec0', fontWeight: '500' }}>{day}</Typography>
  //         ))}
  //       </Box>
  //       {/* Grid System Cells */}
  //       <Box display="grid" gridTemplateColumns="repeat(7, 1fr)" gap={1}>
  //         {gridCells}
  //       </Box>
  //     </Box>
  //   );
  // }

  getCamerahealthPastReports = async () => {
    this.setState({ showPastReportsCard: true }); // Clear previous data and messages when fetching new report
        try {
          this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken getGroupsList---------", access_tocken);
          let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
          }
          const deviceId = this.state.deviceId || "";
           // Ensure deviceId is defined for URL construction
          console.log("Fetching data from:", urls.GET_PAST_CAMERA_HEALTH_REPORT_PER_DEVICE); // Update URL for fetching sites
          const response = await get(urls.GET_PAST_CAMERA_HEALTH_REPORT_PER_DEVICE(deviceId, this.state.startDate, this.state.endDate, this.state.pageNo), headers);
          console.log("response getCamerahealthPastReports ===> ", response);
          this.stopLoading();
          if (!response || response.success === false) {
            console.error("Failed to fetch getCamerahealthPastReports.");
            this.setState({ pastReportData: [], responseMessage: "No report data found for the selected filters.", summaryData: null, pageNo: 1, totalCount: 10, nextPage: null, previousPage: null });
            return;
          }
          if (!response.results?.data || response.results?.data.length === 0) {
            this.setState({ pastReportData: [], responseMessage: "No report data found for the selected filters." });
            return;
          }

          this.setState({
            responseMessage:'', 
            pastReportData: response.results?.data,
            nextPage: response.next,
            totalCount: response.count,
            previousPage: response.previous,
            summaryData: response.results?.summary || null,
          });
        } catch (error) {
          console.error("Error in getCamerahealthPastReports:", error);
          this.setState({ pastReportData: [], responseMessage: "An error occurred while fetching report data.", summaryData: null });
        }
      };

  handleNextPage = () => {
    if (this.state.nextPage) {
      this.setState(
        (prevState) => ({
          pageNo: prevState.pageNo + 1,
        }),
        () => {
          this.getCamerahealthPastReports();
        }
      );
    }
  };

  handlePrevPage = () => {
    if (this.state.previousPage) {
      this.setState(
        (prevState) => ({
          pageNo: prevState.pageNo - 1,
        }),
        () => {
          this.getCamerahealthPastReports();
        }
      );
    }
  };

  handlePastReportFilterTypeChange = (e) => {
    const value = e.target.value;
    let todayDate = new Date().toISOString().split("T")[0]
    this.setState({ 
      specify_past_report_type: value,
      sitename: "",
      deviceId: null,
      devicename: "",
      devices_count:null,
      devices : [],
      // durationFilter: "24_hours", // New state for duration filter
      startDate: todayDate,  // from date
      endDate: todayDate,    // to date
      showPastReportsCard: false,
      totalAlerts: null,
      summaryData: null,
      pageNo: 1,
     });
  }

      
  render() {
    const{site_list, sitename, devices, cameras, todayDate, startDate, endDate, devicename, cameraName,
       error, warning, warning1, groups_list, groupname, showModal, reportStatusMessage, deviceId, 
       warning_alert_report_data, warning_alert_report_data_24h, showPastReportsCard, selectedMonthIndex, selectedDateStr, pastReportData, offlineChartData, summaryData} = this.state
    
    const hasChartData =
      this.state.series[0]?.data?.some(v => v > 0) ||
      this.state.series[1]?.data?.some(v => v > 0);
    const isDeviceDisabled = (this.state.devices_count && 
          (
            (this.state.devices_count.total_device_count === (this.state.devices_count.total_device_status_inactive_count + this.state.devices_count.total_status_offline_count))
          )) || devices.length === 0 ;

    // const monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // const currentMonthLimit = new Date().getMonth(); // Dynamic cutoff up to current month
    // // Last 3 months including current month
    // const allowedMonths = [
    //   currentMonthLimit - 2,
    //   currentMonthLimit - 1,
    //   currentMonthLimit
    // ].filter(month => month >= 0);

    // Is the chart currently empty?
  const isChartEmpty = !offlineChartData || offlineChartData.length === 0;

  // ✅ FIX: If empty, feed Recharts fake slots so it draws gridlines inside the box
  const chartDataToRender = isChartEmpty 
    ? [ { displayDate: " " }, { displayDate: "  " }, { displayDate: "   " }, { displayDate: "    " } ]
    : offlineChartData;

    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <div className="by-sites-page" style={{height: "100vh", overflowY: "scroll"}}>
          {/* Global connectivity monitor */}
          <InternetConnectionDetector />
          <Navigationbar />
          {/* deleted the commented code for group wise filtering on 29-04-2026, if required view commit before the mentioned date */}
        {/* -----------------end of div---------------- */}
        <div className="graph_selection_boxes" style={{display:'flex', justifyContent:'right', gap:'15px', marginTop:'18px'}}>
                    <select
                      name="durationFilter"
                      value={this.state.durationFilter}
                      // onChange={(e) => this.setState({ durationFilter: e.target.value })}
                      onChange={(e) => this.handleDurationFilterChange(e)}
                      style={{ width: '22%', padding: '8px', fontSize:'14px', height:'34px', backgroundColor:'#121212', color:'#c0c0c0' }}
                    >
                      <option value="24_hours" >24 Hours Analysis</option>
                      <option value="custom" >Custom duration based Alerts & Offline Metrics</option>
                      <option value="past_reports" >View CameraHealth Past Reports</option>
                      
                    </select>

                    {this.state.durationFilter === "past_reports" && (
                      <select
                      name="specify_past_report_type"
                      value={this.state.specify_past_report_type}
                      onChange={(e) => this.handlePastReportFilterTypeChange(e)}
                      style={{ width: '30%', padding: '8px', fontSize:'14px', height:'34px', backgroundColor:'#121212', color:'#c0c0c0' }}
                    >
                      {/* <option value=""  disabled>Select report type</option> */}
                      <option value="all_devices" >All devices' report</option>
                      <option value="specific_device" >Specific Device's report</option>
                      
                    </select>
                    )}
                    
                    {(this.state.durationFilter === "24_hours" || this.state.durationFilter === "custom" || this.state.specify_past_report_type === "specific_device" ) && this.state.site_list && (
                    <select
                          name="sitename"
                          // title="If you cannot find a device type, contact the admin"
                          value={sitename}
                          onChange={this.handleInputChange}
                          style={{ width: '20%', padding: '8px', fontSize:'13px', height:'34px', backgroundColor:'#121212', color:'#c0c0c0' }}
                        >
                          <option value="" disabled>Select site to view details</option>
                          {site_list.map((type) => (
                              <option key={type.id} value={type.id}>
                                  {type.sitename}
                              </option>
                          ))}
                    </select>
                    )}
                    {sitename && (
                    <Select
                          name="devicename"
                          // title="If you cannot find a device type, contact the admin"
                          value={devicename}
                          onChange={this.handleInputChange}
                          sx={{ width: '23%', padding: '8px', fontSize:'13px', height:'34px', backgroundColor:'#121212', color:'#c0c0c0' }}
                          displayEmpty
                          // size="small"
                        >
                          <MenuItem sx={{fontSize:'14px'}} value="" disabled>Select device to view details</MenuItem>
                          {Array.isArray(devices) ? (
                              devices.map((type) => (
                                <MenuItem 
                                  key={type.id}
                                  value={type.device_id}
                                  disabled={type.device_status === 'inactive' || type.status === 'inactive'}
                                  // disabled={type.device_status === 'inactive'}
                                >
                                  {/* <span style={{display: 'flex', justifyContent: 'space-between'}}>
                                  {type.device_name}
                                  <p style={{color:'#aeaeae', fontStyle:'italic'}}>{(type.device_status === 'inactive' || type.status === 'inactive') && '(Inactive)'}</p>
                                  </span> */}
                                  <Box display="flex" gap={2}>
                                    <Typography sx={{fontSize:'14px'}}>{type.device_name}</Typography>

                                    {(type.device_status === 'inactive') ? (
                                      <Typography
                                        sx={{ color: "#ddb9b9", fontStyle: "italic", fontSize:'14px' }}
                                      >
                                        (Inactive)
                                      </Typography>
                                    ):(
                                      type.status === 'inactive' ? (
                                        <Typography
                                        sx={{ color: "#ddb9b9", fontStyle: "italic", fontSize:'14px' }}
                                      >
                                        (Offline)
                                      </Typography>
                                      ):("")
                                    )}
                                  </Box>
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem value="" disabled>
                                No device found
                              </MenuItem>
                            )}
                    </Select>
                    )}
                    {/* Date Selection */}
                    {(this.state.durationFilter === "24_hours")  ? null : (
                      <>
                        <TextField
                            label="Start Date"
                            type="date"
                            variant="outlined"
                            size="small"
                            name="startDate"
                            fontSize="12px"
                            color="#c0c0c0"
                            value={startDate}
                            onChange={this.handleDateChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{ min: "2022-01-01" }}  // Allow selection of previous months (or any desired start date)
                            sx={{
                                  width:170,
                                  "& input[type='date']::-webkit-calendar-picker-indicator": {
                                  filter: "invert(1)", // makes icon white
                                  cursor: "pointer",
                                },
                              }}
                        />

                        <TextField
                            label="End Date"
                            type="date"
                            variant="outlined"
                            size="small"
                            color="#c0c0c0"
                            name="endDate"
                            value={endDate}
                            onChange={this.handleDateChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{ min: startDate || todayDate }} // Ensure end date is >= start date or today
                            sx={{
                              width:170,
                              "& input[type='date']::-webkit-calendar-picker-indicator": {
                                  filter: "invert(1)", // makes icon white
                                  cursor: "pointer",
                                },
                            }}
                        />
                      </>
                    )}
                    {/* {sitename && devicename && (
                    <select
                        name="cameraName"
                        value={cameraName}
                        onChange={this.handleInputChange}
                        style={{ width: '23%', padding: '8px', fontSize: '13px', height: '34px' }}
                      >
                        <option value="" disabled>Select camera to view details</option>
                        {Array.isArray(cameras) ? (
                          cameras.map((camera) => (
                            <option key={camera.id} value={camera.id}>
                              {camera.camera_name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>No cameras found</option>
                        )}
                      </select>
                    )} */}
                    <div className="by-sites-filter-action">
                      {( this.state.durationFilter === "past_reports" && this.state.specify_past_report_type !== "specific_device" ) ? (
                        <Button id="rowsPerPageButton" 
                          sx={{fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center", margin:'0px' }}
                          onClick={this.getCamerahealthPastReports}
                        >Apply
                    </Button>
                        ) :
                        (
                        <Button id="rowsPerPageButton" 
                          sx={{fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center", margin:'0px', 
                             "&.MuiButton-root": {
                              cursor:
                                (deviceId === null || !deviceId || isDeviceDisabled)
                                  ? "not-allowed"
                                  : "pointer",
                            },

                            "&.Mui-disabled": {
                               pointerEvents: "auto !important",
                                cursor: "not-allowed !important",
                            } }}
                          onClick={this.state.durationFilter === "24_hours" ? this.getReportData : this.state.durationFilter === "custom" ? this.getAlertReportData : this.getCamerahealthPastReports}
                          // disabled={this.state.devices_count.total_device_count === this.state.devices_count.total_device_status_inactive_count}
                          disabled={deviceId === null || !deviceId || isDeviceDisabled}
                        >Apply
                    </Button>
                        )}
                    
                    </div>
                    <Button id="clearUserLogButton" 
                        style={{fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center", margin:'0px'}}
                        onClick={this.clearFilter}
                    >Clear
                    </Button>
          
                    {/* <Button style={{backgroundColor:'#848c95', color:'white', fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center"}}>Download Report</Button> */}
                    {this.state.durationFilter === "24_hours" && (
                    <img src={ReportDownloadIcon} 
                      alt="report-download" width="40px" height="40px" title="Download Report" 
                      style={{cursor: (!hasChartData || (isDeviceDisabled && (this.state.taskStatus === "PROCESSING"))) ? 'not-allowed' : 'pointer'}} 
                      // disabled={this.state.taskStatus === "PROCESSING"}
                       
                      onClick={(!hasChartData || (isDeviceDisabled && (this.state.taskStatus === "PROCESSING"))) ? null: this.DownloadReport}
                      />
                    )}
        </div>
        <p className="by-sites-filter-help" style={{textAlign:'right', fontSize:'13px', color:'#a4c4f1', paddingRight:'15px'}}>Select above filter(s) and apply to view and/or download the report</p>
        <hr style={{borderColor:'#656565db', borderWidth: '0.005px'}}/>
        <div className="app by-sites-content"
          style={{marginLeft:'7%', height:'100%',
          //  overflowY:'scroll',
            paddingBottom:'105px',
           "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#1976d2",
            borderRadius: "8px",
          },
            }}>
                  
                  
          <p style={{textAlign:'center', fontSize:'15.2px', color:'#a4c4f1', fontWeight:'bold', marginLeft:'2%'}}>
            {this.state.durationFilter === "24_hours" ? "24 Hours Analysis" : this.state.durationFilter === "custom" ? "Custom Duration Analysis" : null} <br/>
            {error ? (
              <Alert severity="error">Server Error! Could not fetch the Overall system report!</Alert>
          ) : warning ? (
              <Alert severity="warning">No report data is available !</Alert>
          ) : warning1 ? (
            <Alert severity="warning">No site(s) available. Please add sites first or contact admin!</Alert>
        ) : warning_alert_report_data ? (
          <Alert severity="warning">Please select a device.</Alert>
          )
        : null}
          </p>
          {this.state.durationFilter === "24_hours" && (
          <>
            <div className="row" style={{marginTop:'40px'}}>
              {/* camera health analysis */}
              <div className="mixed-chart by-sites-chart by-sites-chart-health">
                <Chart
                  options={this.state.options}
                  series={this.state.series}
                  type="bar"
                  width="100%"
                  height="500"
                />
              </div>
              {/* Image quality analysis */}
              <div className="mixed-chart by-sites-chart by-sites-chart-quality">
                <Chart
                  options={this.state.options1}
                  series={this.state.series1}
                  type="bar"
                  width="100%"
                  height="450"
                />
              </div>
            </div>

            {/* Alert message for device selection */}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center", // ✅ center horizontally
                alignItems: "center",
              }}
            >
              <div className="by-sites-alert-message" style={{ width: "450px" }}>
                {warning_alert_report_data_24h && (
                  <Alert severity="warning">
                    Please select a device to view alerts count by camera.
                  </Alert>
                )}
              </div>
            </div>
            
            {/* Alerts Analysis and device offline occurrence analysis */}
            <div className="row" style={{marginTop:'30px'}}>
              <div className="by-sites-chart-column" style={{ width: '490px' }}>
                  {this.state.totalAlerts !== null && (
                  <Box sx={{ mb: '15px' }}>
                    <Typography
                      sx={{
                        width: '250px',
                        height: '50px',
                        border: '1px solid #477fa9',
                        borderRadius: '4px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '10px',
                        alignItems: 'center'
                      }}>
                      <span>
                        < NotificationsIcon sx={{ color: '#c3ccd8', backgroundColor:'#3262a5', borderRadius: '50%', fontSize: '35px', verticalAlign: 'middle' }} />
                      </span>
                      <Box>

                        <div style={{ color: '#3262a5', fontSize: '20px', fontWeight: 'bold' }}>
                          {this.state.totalAlerts} <span style={{fontSize: '10px', fontWeight: 'bold', color: '#c7cfda',}}>Total Alerts (All Cameras) </span>
                        </div> 
                      </Box>
                    </Typography>
                  </Box>
                )}
                  {/* Alerts Analysis */}
                  <div className="mixed-chart by-sites-chart" >
                    <Chart
                      options={this.state.alertOptions}
                      series={this.state.alertSeries}
                      type="bar"
                      width="100%"
                      height="500"
                    />
                  </div>
                </div>
              <div className="by-sites-offline-chart"
                style={{ 
                width: 540, 
                height: 510, 
                backgroundColor: '#1e222d', 
                padding: '20px', 
                borderRadius: '8px',
                marginTop: '50px',
                // boxSizing: 'border-box'
              }}
              // className="mixed-chart"
              >
                <div style={{ 
                  textAlign: 'center', 
                  color: '#ededed', 
                  fontSize: '14px', 
                  fontWeight: 'bold', 
                  marginBottom: '15px' 
                }}>
                  Offline Analysis: Duration & Occurrences
                </div>

                <ResponsiveContainer width="100%" height="90%">
                  <ComposedChart
                    data={offlineChartData}
                    margin={{ top: 10, right: 20, bottom: 20, left: 20 }}
                    barCategoryGap={offlineChartData?.length === 1 ? "35%" : "20%"} // Handles single bar width gracefully
                  >
                    {/* Subtle grid backing */}
                    <CartesianGrid stroke="#2c3446" strokeDasharray="3 3" vertical={false} />

                    {/* X Axis */}
                    <XAxis 
                      dataKey="displayDate" 
                      stroke="#c4c4c4da" 
                      tick={{ fill: '#c4c4c4da', fontSize: 12 }}
                      dy={10}
                    />

                    {/* Y Axis Left: Duration */}
                    <YAxis
                      yAxisId="left"
                      orientation="left"
                      stroke="#ffb347"
                      tick={{ fill: '#ffb347', fontSize: 11 }}
                      tickFormatter={formatSecondsToHMS}
                      domain={[0, 'auto']}
                    />

                    {/* Y Axis Right: Occurrences */}
                    <YAxis
                      yAxisId="right"
                      orientation="right"
                      stroke="#5d97d9"
                      tick={{ fill: '#5d97d9', fontSize: 11 }}
                      allowDecimals={false}
                      domain={[0, 'auto']}
                    />

                    {/* Tooltip & Legend */}
                    <Tooltip content={<CustomTooltip />} />
                    <Legend 
                      verticalAlign="bottom" 
                      height={36} 
                      iconType="square"
                      formatter={(value) => (
                        <span style={{ color: '#E0E0E0', paddingLeft: '5px', fontSize: '12px' }}>
                          {value}
                        </span>
                      )}
                      wrapperStyle={{paddingTop: '10px'}}
                    />

                    {/* The Data Renderers */}
                    <Bar 
                      yAxisId="left" 
                      name="Offline Duration" 
                      dataKey="durationSeconds" 
                      fill="#ffb347" 
                      maxBarSize={60} // Prevents single bars from blowing up to fill the screen
                    />
                    
                    <Line
                      yAxisId="right"
                      name="Offline Occurrence Count"
                      type="monotone"
                      dataKey="occurrenceCount"
                      stroke="#5d97d9"
                      strokeWidth={3}
                      dot={{ r: 5, strokeWidth: 2, fill: '#191e29' }}
                      activeDot={{ r: 7 }}
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            </div>
          </>)}
          {this.state.durationFilter === "custom" && (
            <Box>
              
              <div className="row" style={{marginTop:'20px'}}>
                 {/* Left Section */}
                <div className="by-sites-chart-column" style={{ width: '490px' }}>
                  {this.state.totalAlerts !== null && (
                  <Box sx={{ mb: '15px' }}>
                    <Typography
                      sx={{
                        width: '250px',
                        height: '50px',
                        border: '1px solid #477fa9',
                        borderRadius: '4px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '10px',
                        alignItems: 'center'
                      }}>
                      <span>
                        < NotificationsIcon sx={{ color: '#c3ccd8', backgroundColor:'#3262a5', borderRadius: '50%', fontSize: '35px', verticalAlign: 'middle' }} />
                      </span>
                      <Box>

                        <div style={{ color: '#3262a5', fontSize: '20px', fontWeight: 'bold' }}>
                          {this.state.totalAlerts} <span style={{fontSize: '10px', fontWeight: 'bold', color: '#c7cfda',}}>Total Alerts (All Cameras) </span>
                        </div> 
                      </Box>
                    </Typography>
                  </Box>
                )}
                  {/* Alerts Analysis */}
                  <div className="mixed-chart by-sites-chart" >
                    <Chart
                      options={this.state.alertOptions}
                      series={this.state.alertSeries}
                      type="bar"
                      width="100%"
                      height="500"
                    />
                    <Typography sx={{fontSize: "12px", color: "#7f98cc"}}>
                      (Note: Category-wise counts may overlap when multiple objects are detected in a single alert)
                    </Typography>
                  </div>
                </div>
                {/* Offline Analysis */}
                <div className="by-sites-offline-chart"
                  style={{ 
                  width: 540, 
                  height: 500, 
                  backgroundColor: '#1e222d', 
                  padding: '20px', 
                  borderRadius: '8px',
                  marginTop: '50px',
                }}
                >
                  <div style={{ 
                    textAlign: 'center', 
                    color: '#ededed', 
                    fontSize: '14px', 
                    fontWeight: 'bold', 
                    marginBottom: '18px' 
                  }}>
                    Offline Analysis: Duration & Occurrences
                  </div>

                  <ResponsiveContainer width="100%" height="90%">
                    <ComposedChart
                      data={chartDataToRender}
                      margin={{ top: 10, right: 20, bottom: 20, left: 20 }}
                      barCategoryGap={chartDataToRender?.length === 1 ? "35%" : "20%"} // Handles single bar width gracefully
                    >
                      {/* Subtle grid backing */}
                      {/* <CartesianGrid stroke="#2c3446" strokeDasharray="3 3" vertical={false} /> */}

                      {/* X Axis */}
                      <XAxis 
                        dataKey="displayDate" 
                        stroke="#c4c4c4da" 
                        tick={{ fill: '#c4c4c4da', fontSize: 12 }}
                        dy={10}
                        tickLine={!isChartEmpty} // Hide tiny tick marks if empty
                      />

                      {/* Y Axis Left: Duration */}
                      <YAxis
                        yAxisId="left"
                        orientation="left"
                        stroke="#ffb347"
                        tick={{ fill: '#ffb347', fontSize: 11 }}
                        // tickFormatter={formatSecondsToHMS}
                        // domain={[0, 'auto']}
                        tickFormatter={isChartEmpty ? () => "" : formatSecondsToHMS} // Hide tick numbers if empty
                        domain={[0, isChartEmpty ? 100 : 'auto']} // Give it a fixed empty height scale
                      />

                      {/* Y Axis Right: Occurrences */}
                      <YAxis
                        yAxisId="right"
                        orientation="right"
                        stroke="#5d97d9"
                        tick={{ fill: '#5d97d9', fontSize: 11 }}
                        allowDecimals={false}
                        // domain={[0, 'auto']}
                        tickFormatter={isChartEmpty ? () => "" : (val) => val} // Hide tick numbers if empty
                        domain={[0, isChartEmpty ? 5 : 'auto']} // Give it a fixed empty height scale
                      />

                      {/* Tooltip & Legend */}
                      {/* <Tooltip content={<CustomTooltip />} /> */}
                      {/* Disable interactive tooltips on mock data shapes */}
                      {!isChartEmpty && <Tooltip content={<CustomTooltip />} />}
                      <Legend 
                        verticalAlign="bottom" 
                        height={36} 
                        iconType="square"
                        formatter={(value) => (
                          <span style={{ color: '#E0E0E0', paddingLeft: '5px', fontSize: '12px' }}>
                            {value}
                          </span>
                        )}
                        wrapperStyle={{paddingTop: '10px'}}
                      />

                      {/* The Data Renderers */}
                      <Bar 
                        yAxisId="left" 
                        name="Offline Duration" 
                        dataKey="durationSeconds" 
                        fill="#ffb347" 
                        maxBarSize={60} // Prevents single bars from blowing up to fill the screen
                      />
                      
                      <Line
                        yAxisId="right"
                        name="Offline Occurrence Count"
                        type="monotone"
                        dataKey="occurrenceCount"
                        stroke="#5d97d9"
                        strokeWidth={3}
                        dot={isChartEmpty ? false : { r: 5, strokeWidth: 2, fill: '#191e29' }}
                        // activeDot={{ r: 7 }}
                        activeDot={!isChartEmpty}
                      />
                    </ComposedChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </Box>
          )}
          {/* =========================================================================
              PAST REPORTS CUSTOM FLOW SECTION CARD
              ========================================================================= */}
          {(this.state.durationFilter === "past_reports" && showPastReportsCard) && (
            <Box 
              sx={{ 
                // backgroundColor: '#222a39', 
                backgroundColor: '#1f2634',
                border: '1px solid #2d3748', 
                borderRadius: '8px', 
                p: 2, 
                mb: 4, 
                // maxWidth: '1380px',
                mx: { xs: 0, md: '40px' },
                mt: '2px',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.4)',
                ml: { xs: 0, md: '45px' },
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                gap: "40px",
              }}
            >
              {/* Step 3: Action Drawer / Bottom section once date selection is made */}
              {(startDate && endDate) && (
                <Box sx={{ display: 'flex', flexDirection: 'column', p: "4px", gap: '50px', width: '100%' }}>
                <Box 
                  
                >

                  <Box
                   sx={{ 
                    mt: '3px', 
                    p: '10px', 
                    border: '1.5px solid #2b6cb0', 
                    borderRadius: '8px',
                  }}>
                    {/* <Typography sx={{ color: '#aec4e5', fontSize: '13px' }}>Past Report(s) for Selected Device - </Typography><br/> */}
                    <Typography sx={{ color: '#e7e7e7', fontWeight: 'bold', fontSize: '14px'}}>
                      
                      {/* from {startDate} to {endDate} */}
                       <span style={{ color: '#aec4e5'}}>
                        Past Report(s) for Selected Device - from
                      </span>{" "}
                      {new Date(startDate).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}{" "}
                       <span style={{ color: '#aec4e5'}}>
                        to
                      </span>{" "}
                      {new Date(endDate).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </Typography>
                  </Box>

                  {/* Summary Cards */}
                  {this.state.summaryData && (
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                          xs: '1fr',
                          sm: 'repeat(2, minmax(0, 1fr))',
                          md: 'repeat(5, 1fr)',
                        },
                        gap: '14px',
                        mt: '30px',
                        // mb: '5px',
                        // width: '1280px',
                        // maxWidth: '1380px',
                      }}
                    >

                      {/* Total Cameras */}
                      <Box
                        sx={{
                          backgroundColor: '#273142',
                          border: '1px solid #3b475c',
                          borderRadius: '10px',
                          p: 2,
                          textAlign: 'center',
                        }}
                      >
                        <Typography sx={{ color: '#9fb3c8', fontSize: '13px' }}>
                          Total Cameras Analysed
                        </Typography>

                        <Typography
                          sx={{
                            color: '#ffffff',
                            fontSize: '26px',
                            fontWeight: 'bold',
                            mt: 1,
                          }}
                        >
                          {this.state.summaryData.cameras?.total_cameras || 0}
                        </Typography>
                        <Typography sx={{ color: '#cbd5e0', fontSize: '12px' }}>
                          Total cameras included in health reports across all devices
                        </Typography>
                      </Box>

                      {/* Down Cameras */}
                      <Box
                        sx={{
                          backgroundColor: '#273142',
                          border: '1px solid #3b475c',
                          borderRadius: '10px',
                          p: 2,
                          textAlign: 'center',
                        }}
                      >
                        <Typography sx={{ color: '#9fb3c8', fontSize: '13px' }}>
                          Offline Cameras
                        </Typography>

                        <Typography
                          sx={{
                            color: '#ff6b6b',
                            fontSize: '26px',
                            fontWeight: 'bold',
                            mt: 1,
                          }}
                        >
                          {this.state.summaryData.cameras?.offline_cameras?.count || 0}
                        </Typography>

                        <Typography sx={{ color: '#cbd5e0', fontSize: '12px' }}>
                          {this.state.summaryData.cameras?.offline_cameras?.percentage || 0}%
                        </Typography>
                      </Box>

                      {/* Recording OK */}
                      <Box
                        sx={{
                          backgroundColor: '#273142',
                          border: '1px solid #3b475c',
                          borderRadius: '10px',
                          p: 2,
                          textAlign: 'center',
                        }}
                      >
                        <Typography sx={{ color: '#9fb3c8', fontSize: '13px' }}>
                          Recording Cameras
                        </Typography>

                        <Typography
                          sx={{
                            color: '#65d16c',
                            fontSize: '26px',
                            fontWeight: 'bold',
                            mt: 1,
                          }}
                        >
                          {this.state.summaryData.recording?.cameras_with_recording || 0}
                        </Typography>

                        <Typography sx={{ color: '#cbd5e0', fontSize: '12px' }}>
                          {this.state.summaryData.recording?.recording_percentage || 0}%
                        </Typography>
                      </Box>

                      {/* HDD Healthy */}
                      <Box
                        sx={{
                          backgroundColor: '#273142',
                          border: '1px solid #3b475c',
                          borderRadius: '10px',
                          p: 2,
                          textAlign: 'center',
                        }}
                      >
                        <Typography sx={{ color: '#9fb3c8', fontSize: '13px' }}>
                          HDD Healthy
                        </Typography>

                        <Typography
                          sx={{
                            color: '#4fd1c5',
                            fontSize: '26px',
                            fontWeight: 'bold',
                            mt: 1,
                          }}
                        >
                          {this.state.summaryData.hdd?.healthy_devices || 0}
                        </Typography>

                        <Typography sx={{ color: '#cbd5e0', fontSize: '12px' }}>
                          {this.state.summaryData.hdd?.healthy_percentage || 0}%
                        </Typography>
                      </Box>

                      {/* Timezone Match */}
                      <Box
                        sx={{
                          backgroundColor: '#273142',
                          border: '1px solid #3b475c',
                          borderRadius: '10px',
                          p: 2,
                          textAlign: 'center',
                        }}
                      >
                        <Typography sx={{ color: '#9fb3c8', fontSize: '13px' }}>
                          Timezone Match
                        </Typography>

                        <Typography
                          sx={{
                            color: '#f6c177',
                            fontSize: '26px',
                            fontWeight: 'bold',
                            mt: 1,
                          }}
                        >
                          {this.state.summaryData.timezone?.matched_devices || 0}
                        </Typography>

                        <Typography sx={{ color: '#cbd5e0', fontSize: '12px' }}>
                          {this.state.summaryData.timezone?.matched_percentage || 0}%
                        </Typography>
                      </Box>

                    </Box>
                  )}
                 
                  
                </Box>
                
                {/* table of past report records */}
                <Box
                  sx={{
                    // width: '1300px',
                    // maxWidth: '1380px',
                    // margin : '30px auto',
                    maxHeight: '400px',
                    overflow: 'auto',
                    border: '1px solid #3b475c',
                    borderRadius: '8px',
                    "&::-webkit-scrollbar": { width: "6px" },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#1976d2",
                      borderRadius: "8px",
                    },
                  }}
                >
                  {this.state.responseMessage && (
                                    <Typography sx={{ color: '#e53e3e', fontSize: '13px', fontWeight: '500' }}>
                                      {this.state.responseMessage}
                                    </Typography>
                                  )}
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      color: 'white',
                      fontSize: '13px',
                      tableLayout: 'auto',
                    }}
                  >
                    <thead
                      style={{
                        // position: 'sticky',
                        // top: 0,
                        backgroundColor: '#293141',
                        // zIndex: '100',
                      }}
                    >
                      <tr>
                        <td style={tdStyleLabel}>Date</td>
                        <td style={tdStyleLabel}>
                          {typeof pastReportData?.[0]?.device_name === "number"
                            ? "Devices Count"
                            : "Device Name"}
                        </td>
                        <td style={tdStyleLabel}>Total Cameras<br/>Analysed</td>
                        <td style={tdStyleLabel}>Online Cameras</td>
                        <td style={tdStyleLabel}>Offline Cameras</td>
                        <td style={tdStyleLabel}>HDD(s)</td>
                        <td style={tdStyleLabel}>HDD Status</td>
                        <td style={tdStyleLabel}>24hr Recording<br/>Cameras</td>
                        {this.state.specify_past_report_type === "specific_device" &&
                          (<td style={tdStyleLabel}>Timezone</td>)}
                        {this.state.specify_past_report_type === "specific_device" && (
                          <td style={tdStyleLabel}>Action</td>
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {pastReportData?.map((report) => (
                        <tr key={report.id}>
                          <td style={tdStyleValue}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {report.report_date} {report.report_time ? `${report.report_time}` : ""}
                              <TooltipMUI 
                                title={`Timezone: ${report.timezone ? report.timezone : "N/A"}`}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: '#283348',
                                      color: '#fff',
                                      fontSize: '12px',
                                      border: '1px solid #99acb8',
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: '#283348',
                                    },
                                  },
                                }}
                                 
                              >
                                <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.8, color: 'white' }} />
                              </TooltipMUI>
                            </div>
                          </td>
                          <td style={tdStyleValue}>{report.device_name}</td>

                          <td style={tdStyleValue}>
                            {report.total_cameras}
                          </td>

                          <td
                            style={{
                              textAlign: 'center',
                              padding: '10px',
                              borderBottom: '1px solid #3b475c',
                              color: '#71e879'
                            }}
                          >
                            {report.online_cameras}
                          </td>

                          <td
                            style={{
                              textAlign: 'center',
                              padding: '10px',
                              borderBottom: '1px solid #3b475c',
                              color: '#ce5353'
                            }}
                          >
                            {report.offline_cameras === 0 ? '-' : report.offline_cameras}
                          </td>

                          <td style={tdStyleValue}>
                            {report.hdd_status === "No Disk" ? '-' : report.hdd_status}
                          </td>

                          <td 
                          style={{
                              textAlign: 'center',
                              padding: '10px',
                              borderBottom: '1px solid #3b475c',
                              color:
                                report.hdd_status_ok === "Healthy"
                                  ? '#65d16c'
                                  : '#f0b74c',
                              fontWeight: 'bold'
                            }}
                          >
                            {(report.hdd_status === "0/0" || report.hdd_status === "No Disk" || report.hdd_status === null) ? "-" : report.hdd_status_ok}
                          </td>

                          <td style={{
                            padding: '10px',
                            borderBottom: '1px solid #3b475c',
                            color: report.total_cameras === report.cameras_with_recording ? '#65d16c' : '#ce5353',
                            textAlign: 'center'
                          }}>
                            {report.cameras_with_recording}
                          </td>

                          {this.state.specify_past_report_type === "specific_device" &&
                          (<td
                            style={{
                              textAlign: 'center',
                              padding: '10px',
                              borderBottom: '1px solid #3b475c',
                              color:
                                report.timezone_match_status === "Matched"
                                  ? '#65d16c'
                                  : '#ce5353',
                              fontWeight:'bold'
                            }}
                          >
                            {(report.timezone_match_status === "NULL" || report.timezone_match_status === null) ? "N/A" : report.timezone_match_status }
                          </td>
                          )}

                          {this.state.specify_past_report_type === "specific_device" &&
                          (<td style={tdStyleValue}>
                            <Button
                              variant="outlined"
                              component="a"
                              href={report.s3_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{
                                textTransform: 'none',
                                color: '#83b7ed',
                                fontWeight: 'bold',
                                fontSize: '13px',
                                px: 3,
                                borderRadius: '6px',
                                backgroundColor: 'transparent',
                                '&:hover': {
                                  borderColor: '#cbd5e0',
                                  backgroundColor: '#2d3748'
                                },
                              }}
                            >
                              View PDF
                            </Button>
                          </td>)}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
                <Box sx={{display:'flex', justifyContent: 'center', alignItems: 'center', gap: '20px'}}>
                  <Button
                    id="rowsPerPageButton"
                    onClick={this.handlePrevPage}
                    disabled={!this.state.previousPage}
                    sx={{
                      fontSize:'12px', fontWeight:'bold', height: "30px", display: "flex", alignItems: "center", margin:'0px',
                    '&.Mui-disabled': {
                        backgroundColor: '#777',
                        borderColor: '#555'
                      }
                    }}
                  >
                    Prev
                  </Button>

                  <Typography
                    sx={{
                      color: 'white',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                  >
                    {this.state.pageNo} / {Math.ceil(this.state.totalCount / 10)}
                  </Typography>

                  <Button
                    id="rowsPerPageButton"
                    onClick={this.handleNextPage}
                    disabled={!this.state.nextPage}
                    sx={{
                      fontSize:'12px', fontWeight:'bold', height: "30px", display: "flex", alignItems: "center", margin:'0px',
                      '&.Mui-disabled': {
                        backgroundColor: '#777',
                        borderColor: '#555'
                      }
                    }}
                  >
                    Next
                  </Button>
                </Box>
              </Box>
                
              )}
              
            </Box>
          )}

          {/* =========================================================================
              ORIGINAL CHARTS / PLOTS GRAPHS VIEW RENDERING BLOCK
              ========================================================================= */}
        </div>
        {/* Backdrop with Circular Progress */}
        <Backdrop open={this.state.open_progress_bar} style={{ zIndex: 1600 }}>
              <div className="custom-spinner">
                  <div className="circle"></div>
                  <div className="circle tilted"></div>
                  <img src={this.state.storedLogo ? this.state.storedLogo : WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
              </div>
        </Backdrop>

      {showModal && (
                        <div className="modal-device-add">
                          <div className="modal-content">
                            <div style={{backgroundColor:'#003366', color:'#fff', height:'1.5cm', width:'100%'}}>
                              <button className="close-button" style={{ color:'black', backgroundColor:'white'}} onClick={this.handleCloseModal}>
                                  &times;
                              </button>
                            <h3 style={{display:'flext',textAlign:'center', justifyContent:'center', width:'100%'}}>Report Downloading Logs</h3>
                        
                            </div>
                            <div style={{ marginTop: "20px", textAlign: "left", width:"100%" }}>
                                {/* {this.state.responseTaskId ? ( */}
                                <div style={{
                                  // backgroundColor:'#f4f4f4',
                                    height:'3.5cm', width:'100%', padding:'15px'}}>
                                  <h3>{reportStatusMessage}</h3>
                                  
                                </div>
                                {/* ):(
                                  <div style={{backgroundColor:'#f4f4f4',  height:'2.5cm', width:'100%', padding:'15px'}}>
                                  <h3 style={{color:"green"}}>Report downloading is completed!</h3>
                                  <p>Please wait to let the report open.</p>
                                </div>
                                )
                                } */}
                                {this.state.taskStatus === "PROCESSING" && (
                              <ul style={{ paddingLeft: "20px", listStyleType: "none" }}>
                                
                                  <li style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                                    
                                    <p>This may take a few minutes</p>
                                  </li>
        
                            {/* {this.state.open_progress_bar1 && this.state.currentTaskIndex < this.state.taskStatus.length &&
                              this.state.taskStatus[this.state.currentTaskIndex] !== "✅ Task completed!" && ( */}
                                <Box style={{ zIndex: "1610" }}>
                                  <LinearProgress />
                                </Box>
                              {/* )} */}
                          </ul>
                            )}
                                
                            </div>
                            
                          </div>
                        </div>
                      )}
        </div>
      </ThemeProvider>
    );
  }
}

export default withNavigate(BySites);
